import React, { useEffect, useState } from "react";
import "../../Admin/styles/main.scss";
import { Button, Dialog } from "@mui/material";
import notification_icon from "../../Admin/assets/icons/notification-icon.svg";
import logout from "../../Admin/assets/icons/logout_button.svg";
import Image from "../../Utils/getImage";
import instance from "../../Utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';

const Topbar = () => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [openLogoutPopup, setOpenLogoutPopup] = useState(false);


  const getAdmin = async () => {
    try {
      const response = await instance.get('/Admin/getAdminById',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      setData(response?.data?.data)
    } catch (err) {
      toast.error(err?.response?.data?.message)
    }
  }

  useEffect(() => {
    getAdmin();
  }, [])

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('id');
    window.location.href = '/admin/login';
  }

  return (
    <section className="topbar">
      <div className="topbar-main">
        {/* <img src={notification_icon} alt="notification_icon" /> */}
        <div onClick={() => navigate('/admin/settings')} className="profile-menu">
          <Image
            src={data?.profile_pic}
            alt="profile"
            style={{ margin: "0px 20px 0px 35px", cursor: "pointer" }}
            className='top-bar-details'
            width={40}
            height={40}
          />
          <Button >{data?.name}</Button>
        </div>
        {/* <div className="topbar-login"> */}
        <div className="logout-btn">
          {/* <img src={logout} alt="logout" /> */}
          <Button startIcon={<LogoutIcon />} onClick={() => setOpenLogoutPopup(true)}>
            Logout
          </Button>
        </div>
        {/* </div> */}
        <Dialog
          open={openLogoutPopup}
          onClose={() => setOpenLogoutPopup(false)}
          PaperProps={{
            sx: {
              borderRadius: "16px",
              padding: "20px",
              width: "420px",
            },
          }}
        >
          <div style={{ textAlign: "center", padding: "10px 0" }}>
            <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>
              Logout Confirmation
            </h2>

            <p style={{ marginTop: "12px", fontSize: "16px", color: "#555" }}>
              Are you sure you want to logout?
            </p>

            <div
              style={{
                marginTop: "25px",
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => setOpenLogoutPopup(false)}
                sx={{
                  width: "120px",
                  borderRadius: "10px",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                color="error"
                onClick={handleLogout}
                sx={{
                  width: "120px",
                  borderRadius: "10px",
                  textTransform: "none",
                }}
              >
                Logout
              </Button>
            </div>
          </div>
        </Dialog>


      </div>
    </section>
  );
};

export default Topbar;
